// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.leftOffset {
  position: relative;
  left: 11px;
}
.leftOffset::after {
  content: ":";
  margin-left: 2px;
}

.labelWithOffset {
  position: relative;
  left: 12px;
  white-space: pre-line;
}

.ant-col-offset-8 {
  margin-left: 22% !important;
}

.ant-select-compact-item:not(.ant-select-compact-last-item) {
  margin-right: 10px !important;
}

.offset {
  margin-left: 0px;
  position: absolute;
  right: -21px;
  top: -12px;
}

.dragDropContainer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 10px;
  row-gap: 10px;
}

.tag {
  display: inline-block;
  padding: 5px 10px;
  border: 3px solid #f4f5f4;
  border-radius: 5px;
  cursor: move;
}

.dragDroplabel {
  min-height: 70px;
}

.mti-container {
  display: flex;
  width: 100%;
}

.extraIcons {
  position: absolute;
  left: calc(100% + 5px);
  display: flex;
  align-items: center;
  column-gap: 10px;
  height: 100%;
}

.dragger {
  cursor: move;
}

.uploadContainer {
  display: grid;
  column-gap: 10px;
}

.dynamic-delete-button {
  color: #999;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

[data-theme=dark] .dynamic-delete-button {
  color: rgba(255, 255, 255, 0.45);
}

[data-theme=dark] .dynamic-delete-button:hover {
  color: rgba(255, 255, 255, 0.65);
}

.loader {
  font-weight: bold;
  font-family: "Inter", sans-serif;
  font-size: 30px;
  margin: 200px 0 0 150px;
  position: absolute;
  animation: l1 1s linear infinite alternate;
}

.loader:before {
  content: "Loading...";
}

@keyframes l1 {
  to {
    opacity: 0;
  }
}
.pdfviewer-container {
  width: 250px;
  height: 250px;
  overflow: hidden;
  cursor: pointer;
}

.pdfviewer-container1 {
  width: 100%;
  height: 800px;
  overflow-y: scroll;
}

.pdfviewer-container2 {
  width: auto;
  height: 750px;
  overflow-y: hidden;
  margin-top: 5%;
}

.pdfviewer-container3 {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-box {
  position: absolute;
  display: flex;
  z-index: 19999;
  top: 90%;
  left: 45%;
}

.pdf-button {
  margin: 20px;
  width: 50px;
  font-size: 20px;
  font-weight: 800;
  padding: 0;
  height: auto;
  border: 1px solid black;
  border-radius: 5px;
  z-index: 9999;
  background-color: rgba(172, 255, 47, 0.321);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.modal-buttons {
  margin-top: 15px;
}

.confirm-button,
.cancel-button {
  margin: 5px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.confirm-button {
  background-color: #d9534f;
  /* Red for delete action */
  color: white;
}

.cancel-button {
  background-color: #5bc0de;
  /* Blue for cancel */
  color: white;
}

.multiselect-checkbox-dropdown .ant-select-item,
.select-checkbox-dropdown .ant-select-item {
  position: relative;
  padding-left: 32px !important;
}
.multiselect-checkbox-dropdown .ant-select-item::before,
.select-checkbox-dropdown .ant-select-item::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 1.5px solid #d9d9d9;
  border-radius: 2px;
  background-color: #fff;
  box-sizing: border-box;
  transition: all 0.2s;
}
.multiselect-checkbox-dropdown .ant-select-item:hover::before,
.select-checkbox-dropdown .ant-select-item:hover::before {
  border-color: #40a9ff;
}
.multiselect-checkbox-dropdown .ant-select-item.ant-select-item-option-active::before,
.select-checkbox-dropdown .ant-select-item.ant-select-item-option-active::before {
  border-color: #40a9ff;
}
.multiselect-checkbox-dropdown .ant-select-item-option-selected::before,
.select-checkbox-dropdown .ant-select-item-option-selected::before {
  background-color: #1890ff;
  border-color: #1890ff;
}
.multiselect-checkbox-dropdown .ant-select-item-option-selected::after,
.select-checkbox-dropdown .ant-select-item-option-selected::after {
  content: "";
  position: absolute;
  left: 17px;
  top: 50%;
  transform: translateY(-60%) rotate(45deg);
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  pointer-events: none;
}
.multiselect-checkbox-dropdown .ant-select-item-option-state,
.select-checkbox-dropdown .ant-select-item-option-state {
  display: none !important;
}

.content-rounded-field {
  border-radius: 8px;
}
.content-rounded-field.ant-input, .content-rounded-field.ant-input-number, .content-rounded-field.ant-picker, .content-rounded-field.ant-input-affix-wrapper {
  height: 40px;
  border-color: #d9e2ec;
  background: #ffffff;
  border-radius: 8px;
}
.content-rounded-field .content-rounded-display {
  border: 1px solid #d9e2ec;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px 12px;
}
.content-rounded-field.ant-input-number {
  display: inline-flex;
  align-items: center;
}
.content-rounded-field.ant-input:focus, .content-rounded-field.ant-input-focused, .content-rounded-field.ant-input-affix-wrapper-focused, .content-rounded-field.ant-input-number:focus, .content-rounded-field.ant-input-number-focused, .content-rounded-field.ant-picker-focused {
  border-color: #075dc5;
  box-shadow: 0 0 0 2px rgba(7, 93, 197, 0.1);
}
.content-rounded-field.ant-picker:hover {
  border-color: #075dc5;
}
.content-rounded-field.ant-input-affix-wrapper:hover {
  border-color: #075dc5;
}
.content-rounded-field.ant-select .ant-select-selector {
  min-height: 40px;
  border-color: #d9e2ec;
  border-radius: 8px !important;
  background: #ffffff;
  display: flex;
  align-items: center;
}
.content-rounded-field.ant-select:hover .ant-select-selector, .content-rounded-field.ant-select.ant-select-focused .ant-select-selector {
  border-color: #075dc5;
}

[data-theme=dark] .multiselect-checkbox-dropdown .ant-select-item::before {
  border-color: #434343;
  background-color: #1f1f1f;
}
[data-theme=dark] .multiselect-checkbox-dropdown .ant-select-item:hover::before {
  border-color: #177ddc;
}
[data-theme=dark] .multiselect-checkbox-dropdown .ant-select-item.ant-select-item-option-active::before {
  border-color: #177ddc;
}
[data-theme=dark] .multiselect-checkbox-dropdown .ant-select-item-option-selected::before {
  background-color: #177ddc;
  border-color: #177ddc;
}

.ql-snow .ql-picker.ql-header {
  width: 110px;
}

button.ql-newsTable {
  position: relative;
}
button.ql-newsTable::before {
  content: "⊞";
  font-size: 17px;
  font-weight: bold;
  display: inline-block;
  line-height: 18px;
  color: #444;
}
button.ql-newsTable:hover::before {
  color: #004195;
}

.ql-news-table-embed {
  margin: 12px 0;
  cursor: pointer;
}
.ql-news-table-embed table {
  width: 100%;
  border-collapse: collapse;
}`, "",{"version":3,"sources":["webpack://./src/components/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,UAAA;AAEF;AAAE;EACE,YAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAAF;;AAIA;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,aAAA;AADF;;AAIA;EACE,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAKA;EACE,aAAA;EACA,WAAA;AAFF;;AAKA;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,gBAAA;AAFF;;AAMA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,mBAAA;EACA,YAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;EACE,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,0CAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE;IACE,UAAA;EAHF;AACF;AAMA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAJF;;AAOA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAJF;;AAOA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAJF;;AAOA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;AAJF;;AAOA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,2CAAA;AAJF;;AAOA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;;EAEE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAJF;;AAOA;EACE,yBAAA;EACA,0BAAA;EACA,YAAA;AAJF;;AAOA;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;AAJF;;AAUE;;EACE,kBAAA;EACA,6BAAA;AANJ;AASI;;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,oBAAA;AANN;AAUI;;EACE,qBAAA;AAPN;AAWI;;EACE,qBAAA;AARN;AAiBI;;EACE,yBAAA;EACA,qBAAA;AAdN;AAkBI;;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,yCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AAfN;AAoBE;;EACE,wBAAA;AAjBJ;;AAqBA;EACE,kBAAA;AAlBF;AAoBE;EAIE,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,oBAAA;EACA,mBAAA;AAvBJ;AA0BE;EAME,qBAAA;EACA,2CAAA;AA7BJ;AAgCE;EACE,qBAAA;AA9BJ;AAiCE;EACE,qBAAA;AA/BJ;AAmCI;EACE,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAjCN;AAoCI;EAEE,qBAAA;AAnCN;;AA2CM;EACE,qBAAA;EACA,yBAAA;AAxCR;AA2CM;EACE,qBAAA;AAzCR;AA4CM;EACE,qBAAA;AA1CR;AA+CM;EACE,yBAAA;EACA,qBAAA;AA7CR;;AAkDA;EACE,YAAA;AA/CF;;AAkDA;EACE,kBAAA;AA/CF;AAgDE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;AA9CJ;AAgDE;EACE,cAAA;AA9CJ;;AAkDA;EACE,cAAA;EACA,eAAA;AA/CF;AAgDE;EACE,WAAA;EACA,yBAAA;AA9CJ","sourcesContent":[".leftOffset {\n  position: relative;\n  left: 11px;\n\n  &::after {\n    content: ':';\n    margin-left: 2px;\n  }\n}\n\n.labelWithOffset {\n  position: relative;\n  left: 12px;\n  white-space: pre-line;\n}\n\n.ant-col-offset-8 {\n  margin-left: 22% !important;\n}\n\n.ant-select-compact-item:not(.ant-select-compact-last-item) {\n  margin-right: 10px !important;\n}\n\n// used in multipleTwinInput form field\n.offset {\n  margin-left: 0px;\n  position: absolute;\n  right: -21px;\n  top: -12px;\n}\n\n// used in multiSelectInput component\n.dragDropContainer {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  column-gap: 10px;\n  row-gap: 10px;\n}\n\n.tag {\n  display: inline-block;\n  padding: 5px 10px;\n  border: 3px solid #f4f5f4;\n  border-radius: 5px;\n  cursor: move;\n}\n\n.dragDroplabel {\n  min-height: 70px;\n}\n\n// used in multipleTextInput component\n.mti-container {\n  display: flex;\n  width: 100%;\n}\n\n.extraIcons {\n  position: absolute;\n  left: calc(100% + 5px);\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n  height: 100%;\n}\n\n.dragger {\n  cursor: move;\n}\n\n.uploadContainer {\n  display: grid;\n  column-gap: 10px;\n}\n\n// used in multipleTextInput and multipleTwinInpput form field\n.dynamic-delete-button {\n  color: #999;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.dynamic-delete-button:hover {\n  color: #777;\n}\n\n.dynamic-delete-button[disabled] {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n[data-theme='dark'] .dynamic-delete-button {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n[data-theme='dark'] .dynamic-delete-button:hover {\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.loader {\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 30px;\n  margin: 200px 0 0 150px;\n  position: absolute;\n  animation: l1 1s linear infinite alternate;\n}\n\n.loader:before {\n  content: 'Loading...';\n}\n\n@keyframes l1 {\n  to {\n    opacity: 0;\n  }\n}\n\n.pdfviewer-container {\n  width: 250px;\n  height: 250px;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.pdfviewer-container1 {\n  width: 100%;\n  height: 800px;\n  overflow-y: scroll;\n}\n\n.pdfviewer-container2 {\n  width: auto;\n  height: 750px;\n  overflow-y: hidden;\n  margin-top: 5%;\n}\n\n.pdfviewer-container3 {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.button-box {\n  position: absolute;\n  display: flex;\n  z-index: 19999;\n  top: 90%;\n  left: 45%;\n}\n\n.pdf-button {\n  margin: 20px;\n  width: 50px;\n  font-size: 20px;\n  font-weight: 800;\n  padding: 0;\n  height: auto;\n  border: 1px solid black;\n  border-radius: 5px;\n  z-index: 9999;\n  background-color: rgba(172, 255, 47, 0.321);\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.modal-buttons {\n  margin-top: 15px;\n}\n\n.confirm-button,\n.cancel-button {\n  margin: 5px;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n.confirm-button {\n  background-color: #d9534f;\n  /* Red for delete action */\n  color: white;\n}\n\n.cancel-button {\n  background-color: #5bc0de;\n  /* Blue for cancel */\n  color: white;\n}\n\n// Multi-select dropdown checkbox styling\n.multiselect-checkbox-dropdown,\n.select-checkbox-dropdown {\n  .ant-select-item {\n    position: relative;\n    padding-left: 32px !important;\n\n    // Unchecked checkbox visual\n    &::before {\n      content: '';\n      position: absolute;\n      left: 12px;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 16px;\n      height: 16px;\n      border: 1.5px solid #d9d9d9;\n      border-radius: 2px;\n      background-color: #fff;\n      box-sizing: border-box;\n      transition: all 0.2s;\n    }\n\n    // Hover state for checkbox\n    &:hover::before {\n      border-color: #40a9ff;\n    }\n\n    // Focus/active state\n    &.ant-select-item-option-active::before {\n      border-color: #40a9ff;\n    }\n  }\n\n  // Selected item - checked checkbox\n  .ant-select-item-option-selected {\n    // Disable default background if desired - keeping subtle background\n    // background-color: transparent !important;\n\n    &::before {\n      background-color: #1890ff;\n      border-color: #1890ff;\n    }\n\n    // Checkmark inside checkbox\n    &::after {\n      content: '';\n      position: absolute;\n      left: 17px;\n      top: 50%;\n      transform: translateY(-60%) rotate(45deg);\n      width: 5px;\n      height: 9px;\n      border: solid #fff;\n      border-width: 0 2px 2px 0;\n      pointer-events: none;\n    }\n  }\n\n  // Hide the default Ant Design tick/state icon\n  .ant-select-item-option-state {\n    display: none !important;\n  }\n}\n\n.content-rounded-field {\n  border-radius: 8px;\n\n  &.ant-input,\n  &.ant-input-number,\n  &.ant-picker,\n  &.ant-input-affix-wrapper {\n    height: 40px;\n    border-color: #d9e2ec;\n    background: #ffffff;\n    border-radius: 8px;\n  }\n\n  .content-rounded-display {\n    border: 1px solid #d9e2ec;\n    border-radius: 8px;\n    background: #ffffff;\n    padding: 10px 12px;\n  }\n\n  &.ant-input-number {\n    display: inline-flex;\n    align-items: center;\n  }\n\n  &.ant-input:focus,\n  &.ant-input-focused,\n  &.ant-input-affix-wrapper-focused,\n  &.ant-input-number:focus,\n  &.ant-input-number-focused,\n  &.ant-picker-focused {\n    border-color: #075dc5;\n    box-shadow: 0 0 0 2px rgba(7, 93, 197, 0.1);\n  }\n\n  &.ant-picker:hover {\n    border-color: #075dc5;\n  }\n\n  &.ant-input-affix-wrapper:hover {\n    border-color: #075dc5;\n  }\n\n  &.ant-select {\n    .ant-select-selector {\n      min-height: 40px;\n      border-color: #d9e2ec;\n      border-radius: 8px !important;\n      background: #ffffff;\n      display: flex;\n      align-items: center;\n    }\n\n    &:hover .ant-select-selector,\n    &.ant-select-focused .ant-select-selector {\n      border-color: #075dc5;\n    }\n  }\n}\n\n[data-theme='dark'] {\n  .multiselect-checkbox-dropdown {\n    .ant-select-item {\n      &::before {\n        border-color: #434343;\n        background-color: #1f1f1f;\n      }\n\n      &:hover::before {\n        border-color: #177ddc;\n      }\n\n      &.ant-select-item-option-active::before {\n        border-color: #177ddc;\n      }\n    }\n\n    .ant-select-item-option-selected {\n      &::before {\n        background-color: #177ddc;\n        border-color: #177ddc;\n      }\n    }\n  }\n}\n.ql-snow .ql-picker.ql-header {\n  width: 110px;\n}\n\nbutton.ql-newsTable {\n  position: relative;\n  &::before {\n    content: '⊞';\n    font-size: 17px;\n    font-weight: bold;\n    display: inline-block;\n    line-height: 18px;\n    color: #444;\n  }\n  &:hover::before {\n    color: #004195;\n  }\n}\n\n.ql-news-table-embed {\n  margin: 12px 0;\n  cursor: pointer;\n  table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
